import { useContext } from "react";
import { useRef, useEffect } from "react";
import images from "../../images";
import PromptContextProvider from "../../Context/PromptContext";
import Svg from "../Helper/Svg";

const NEG_TRANSLATE = "-translate-y-20";
const NEG_OPACITY = "opacity-0";
const POS_TRANSLATE = "translate-y-5";
const POS_OPACITY = "opacity-100";
const DELAY = (process.env.REACT_APP_PROMPT_TIMER ?? 3) * 1000;
const TRANSITION_DURATION = 150;

const classes = {
  default: `mb-default transition-all pointer-events-none ${NEG_TRANSLATE} ${NEG_OPACITY}`,
  md: `md:right-5 md:w-fit`,
  container: `p-3 flex rounded-md border-l-4 w-fit m-auto pointer-events-auto`,
  h2: "[&>h2]:text-md [&>h2]:font-medium",
  p: "[&>p]:text-sm",
};

export default function BasePrompt({ children, className, promptId }) {
  const promptRef = useRef(null);
  const { clearPrompt } = useContext(PromptContextProvider);

  useEffect(() => {
    const mountTimeoutId = mount();
    const unmountTimeoutId = unmount();

    return () => {
      clearTimeout(mountTimeoutId);
      clearTimeout(unmountTimeoutId);
    };
  }, []);

  function mount() {
    return setTimeout(() => {
      promptRef?.current?.classList.remove(NEG_TRANSLATE, NEG_OPACITY);
      promptRef?.current?.classList.add(POS_TRANSLATE, POS_OPACITY);

      // adds small delay so classes are applied
    }, 10);
  }

  function unmount(delay = DELAY) {
    // adds a timeout on delayed unmount
    // onces timeout runs, removes classes and cleans up timeouts
    return setTimeout(() => {
      promptRef?.current?.classList.remove(POS_TRANSLATE, POS_OPACITY);
      promptRef?.current?.classList.add(NEG_TRANSLATE, NEG_OPACITY);

      return setTimeout(() => {
        clearPrompt(promptId);
      }, TRANSITION_DURATION);
    }, delay);
  }

  return (
    <section
      className={`${classes.default} ${classes.md}`}
      ref={promptRef}
      style={{ transitionDuration: `${TRANSITION_DURATION}ms` }}
    >
      <div className={`${classes.container} ${className}`}>
        <div className={`${classes.h2} ${classes.p}`}>{children}</div>

        <div className="border-l-2 ml-3 pl-3 flex items-center">
          <button className="opacity-50" onClick={() => unmount(0)}>
            <Svg strokeClass="[&>path]:stroke-neutral-600" icon={images.icons.cross} />
          </button>
        </div>
      </div>
    </section>
  );
}
